<p-toast class="toster_sec"></p-toast>
<div class="profile">
    <p-card header="{{this.profileData.userName}}" subheader="{{this.profileData.email}}">
    </p-card>
    <div class="body">
        <div class="associ-div" [ngClass]="this.profileData.email != 'masteradmin@minesnxt.com' ? 'show-associat': 'hide-associat'">
            <p class="p-text"> Associated Unit</p>
            <h6><b>{{this.profileData.units}}</b></h6>
        </div>  
        <div class="rol-div">
            <p class="p-text">Role</p>
            <h6><b>{{this.profileData.roles }}</b></h6>
        </div>      
        
    </div>
</div>